import T from 'mrf/utils/T';
import Button from './Button'; 
import PropTypes from 'prop-types';
import useMRFTranslation from 'mrf/utils/useMRFTranslation';
import { WarningModalDeleteIcon } from 'mrf/styles/basic/icons';

export default function DeleteModal ({ 
    isOpen, 
    onCancel, 
    onConfirm, 
    title, 
    name, 
    additionalInfoModalDelete,  
}) {
    
    const t = useMRFTranslation();

    if (!isOpen) return null;

    let deleteMessage;
    
    if (name) {
        deleteMessage = t(`Do you really want to delete "${name}"?`);
    } else if (title) {
        deleteMessage = t(`Do you really want to delete this ${title.toLowerCase()}?`);
    } else {
        deleteMessage = t('Do you really want to delete this register?');
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <div className="flex items-center">
                    <WarningModalDeleteIcon className="h-6 w-6 text-yellow-500 mr-3" />
                    <h3 className="text-lg font-semibold text-gray-800"><T>Confirm Deletion</T></h3>
                </div>
                <p className="mt-4 text-gray-600">
                    {deleteMessage}
                </p>

                {/* display the additional text if the additionalNotes prop is provided */}
                {additionalInfoModalDelete && (
                    <p className="mt-6 font-semibold italic">
                        <T>{additionalInfoModalDelete}</T>
                    </p>
                )}

                <div className="mt-6 flex justify-end gap-4">
                    <Button 
                        color="secondary" 
                        type="button" 
                        onClick={onCancel}
                    >
                        <T>Cancel</T>
                    </Button>
                    <Button 
                        color="delete" 
                        type="button" 
                        onClick={onConfirm}
                    >
                        <T>Delete</T>
                    </Button>
                </div>
            </div>
        </div>
    );
}

DeleteModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,              // indicates whether the modal is open or not
    onCancel: PropTypes.func.isRequired,            // function to handle the cancel button click
    onConfirm: PropTypes.func.isRequired,           // function to handle the confirm (delete) button click
    title: PropTypes.string,                        // title to describe the type of item being deleted
    name: PropTypes.string,                         // name of the item being deleted
    additionalInfoModalDelete: PropTypes.string,    // additional notes displayed in the delete modal
};